import { Popover } from '@heathmont/moon-core-tw';
import type { TournamentFragment } from '~/client/features/Tournaments/graphql/TournamentFragment.generated';
import LeaderboardList from './LeaderboardList';
import SeeMore from '../SeeMore';

type Props = {
  tournament?: TournamentFragment;
};

const PopoverLeaderboard: React.FC<Props> = ({ tournament }) => (
  <Popover>
    <Popover.Trigger>
      <SeeMore />
    </Popover.Trigger>
    <Popover.Panel className="absolute !-top-[7.5rem] w-[13.25rem] bg-gohan p-4">
      <LeaderboardList tournament={tournament} />
    </Popover.Panel>
  </Popover>
);

export default PopoverLeaderboard;
